import { Cart } from '@peerless/data-access/cart-service/server';
import fetcher from '../client';

export const loadCart = (customerId: string): Promise<Cart> => {
  return fetcher.get('/cart', { customerId });
};
